import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatChipsModule } from '@angular/material/chips';
import { MultipleFilterProperty } from "../../../_model/multiple-filter-property";
import { TableFilters } from "../../../_model/table-response/table-filters";
import { DatePipe } from "@angular/common";
import { Constants } from "../../../_model/constants";
import { ExportService } from "../../../service/export.service";
import { Subscription } from "rxjs";
import { ClientStateService } from "../../navbar/client-state.service";
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { environment } from "../../../../environments/environment";
import { UserService } from "../../../service/user.service";
import { User } from "../../../_model/user/user";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatOptionModule } from "@angular/material/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: "app-reprocessing-multiple-input-filter",
  templateUrl: "./reprocessing-multiple-input-filter.component.html",
  standalone: true,
  imports: [MatChipsModule, MatSelectModule, ReactiveFormsModule, MatFormFieldModule, MatOptionModule, MatProgressSpinnerModule, BsDatepickerModule, MatDatepickerModule, MatNativeDateModule, MatAutocompleteModule, MatButtonModule, MatDialogModule, MatTabsModule, MatToolbarModule, MatListModule, MatSidenavModule, MatExpansionModule, MatSnackBarModule, MatGridListModule, MatCheckboxModule, MatRadioModule, MatIconModule, MatInputModule],
  styleUrls: ["./reprocessing-multiple-input-filter.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReprocessingMultipleInputFilterComponent implements OnInit, OnChanges {
  @Input() tableFilters!: TableFilters[];
  @Output() selectedFilter = new EventEmitter<FormGroup>();
  @Input() calledFilter!: EventEmitter<string>;
  clientSubscription!: Subscription;

  localTableFilters!: TableFilters[];
  filterForms!: FormGroup;
  todayDate!: Date;

  filterArray: Array<MultipleFilterProperty> = [];
  dateFilterSelected = false;
  scheduledStartDate = false;
  dateReceived = false;
  callOnce = false;
  filterApplied = false;
  removable = true;
  filterAdded = false;
  dateFilterAdded = false;
  excelClicked = false;
  isAddCliecked = false;
  searchClicked = false;
  isLoadingResults = false;

  filterArrayForms!: FormGroup;
  bsRangeValue?: Date[];
  today!: Date;
  minDate!: Date;
  maxDate!: Date;
  bsInvalidDate: Date = new Date();
  daterangepickerModel: Date[] = [];
  scheduledminDate!: Date;
  scheduledmaxDate!: Date;
  start_date: any;
  end_date: any;
  constructor(
    private fb: FormBuilder,
    public datepipe: DatePipe,
    private exportService: ExportService, private userService: UserService,
    private clientStateService: ClientStateService, private cdRef: ChangeDetectorRef
  ) {
    this.initializeFilter();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tableFilters']) {
      this.localTableFilters = this.tableFilters;
      this.cdRef.detectChanges();
    }
  }

  ngOnInit() {
    this.localTableFilters = this.tableFilters;
    this.clientSubscription =
      this.clientStateService.clientStateChanged$.subscribe(() => {
        this.initializeFilter();
        this.filterApplied = false;
        this.dateFilterSelected = false;
        this.filterAdded = false;
        this.dateFilterAdded = false;
        this.filterArray = [];
      });
    this.calledFilter.subscribe(() => {
      this.reset();
    });
  }
  ngAfterViewInit() {
    this.localTableFilters = this.tableFilters;
    this.cdRef.detectChanges();
  }
  bsConfig?: Partial<BsDatepickerConfig>;
  colorTheme! : string | null;
  value! :  string | null;
  applyTheme() {
    this.bsConfig = Object.assign({}, { containerClass: 'theme-blue' });
    this.daterangepickerModel = [];
    if (this.filterForms.value.value == 'Scheduled Start Date') {
      const currentYear = new Date().getFullYear();
      this.cdRef.detectChanges();
      this.dateFilterSelected = true;
      this.scheduledStartDate = true;
      this.dateReceived = false;
      this.today = new Date();
      this.scheduledminDate = new Date(this.today.getFullYear(), this.today.getMonth());
      this.scheduledmaxDate = new Date(currentYear + 1, 11, 31);
      this.bsInvalidDate = (new Date(currentYear + 1, 11, 31));
      this.bsRangeValue = undefined;
    }
    else if (this.filterForms.value.value == 'Date Received') {
      this.cdRef.detectChanges();
      this.dateFilterSelected = true;
      this.scheduledStartDate = false;
      this.dateReceived = true;
      this.today = new Date();
      this.minDate = new Date(new Date().setDate(this.today.getDate() - 90));
      this.maxDate = this.today;
      this.bsInvalidDate = this.today;
      this.bsRangeValue = undefined;
    }
    else {
      this.dateFilterSelected = true;
      this.scheduledStartDate = false;
      this.dateReceived = false;
    }
  }

  updateMyDate(newDate: any) {
    if (newDate) {
      this.daterangepickerModel = [new Date(newDate[0]), new Date(newDate[1])];
    }
  }

checkAndCallMethods() {
  // Intercept and validate the Visit ID before proceeding to add, search, or export
  if (this.filterForms.value.tableFilter && this.filterForms.value.tableFilter.displayName === Constants.displayNameReprocessVisitId && this.filterForms.value.value) {
    const cleanValue = String(this.filterForms.value.value).trim();
    this.filterForms.get('value')?.setValue(cleanValue);
    this.filterForms.value.value = cleanValue;

    if (!this.isValidVisitId(cleanValue)) {
      alert(Constants.visitIdErrorAlert);
      return;
    }
  }
  if (this.isAddCliecked) {
    this.addFilter();
  } else if (this.searchClicked) {
    if (this.filterArray.length > 0) {
      const multipleFilterControl = this.filterForms.get("multipleFilterarray");
      // Add a null check here
      if (multipleFilterControl) {
        multipleFilterControl.setValue(this.filterArray);
      }
    }
    this.selectedFilter.emit(this.filterForms);
  } else if (this.excelClicked) {
    if (this.filterArray.length > 0) {
      const multipleFilterControl = this.filterForms.get("multipleFilterarray");
      // Add a null check here
      if (multipleFilterControl) {
        multipleFilterControl.setValue(this.filterArray);
      }
    }
    this.getDatatoExcel(this.filterForms);
  }
}

  isValidVisitId(visitId: string): boolean {
    if (!visitId) {
      return false;
    }
    
    // Convert to string and trim any leading/trailing spaces from copy-pasting
    const cleanVisitId = String(visitId).trim();

    // Allow only alphanumeric characters and hyphens
    const regex = /^[a-zA-Z0-9-]+$/;
    return regex.test(cleanVisitId);
    // Count hyphens and ensure total length is exactly 36 (32 characters + 4 hyphens)
    //const hyphenCount = (cleanVisitId.match(/-/g) || []).length;
    //return regex.test(cleanVisitId) && cleanVisitId.length === 36 && hyphenCount === 4;
  }


  addFilter() {
    let multipleFilterProperty = new MultipleFilterProperty();
    let isDuplicate = false;
    for (let item of this.filterArray) {

      if (item.value === this.filterForms.value.value) {
        isDuplicate = true;
        break;
      }
    }
    let existItem = this.filterArray.filter(item => item.dispalyName === this.filterForms.value.tableFilter.displayName);
    if (this.filterForms.value.tableFilter.displayName === Constants.displayNameReprocessVisitId) {

      // Clean the input value so the trimmed ID is sent to the backend
      this.filterForms.value.value = String(this.filterForms.value.value).trim();

      if (!this.isValidVisitId(this.filterForms.value.value)) {
        //alert('You can only filter by one Visit ID at a time. Only alphanumeric characters and hyphens (-) are allowed.');
        return;
      }
    }

    if (!isDuplicate && (existItem.length < 1 || (existItem.length >= 0 && this.filterForms.value.tableFilter.displayName == Constants.status))) {
      if (this.filterForms.value.tableFilter.displayName == Constants.date) {
        let existDateItem = this.filterArray.filter(item => item.dateValue === this.filterForms.value.tableFilter.displayName);
        if (existDateItem.length < 1) {
          multipleFilterProperty.dispalyName = this.filterForms.value.tableFilter.displayName;
          multipleFilterProperty.column = this.filterForms.value.tableFilter.column;
          multipleFilterProperty.dateValue = this.filterForms.value.tableFilter.displayName;
          multipleFilterProperty.dateBackendName = this.filterForms.value.value
          multipleFilterProperty.origionalStartDateFormat = this.daterangepickerModel[0];
          multipleFilterProperty.origionalEndDateFormat = this.daterangepickerModel[1];
          if(environment.locale == "en-GB"){
            this.start_date = this.datepipe.transform(this.daterangepickerModel[0], Constants.dateFormatEngb);
            this.end_date = this.datepipe.transform(this.daterangepickerModel[1], Constants.dateFormatEngb); 
          }
          else if(environment.locale == "en-US"){
            this.start_date = this.datepipe.transform(this.daterangepickerModel[0], Constants.dateFormaten029);
            this.end_date = this.datepipe.transform(this.daterangepickerModel[1], Constants.dateFormaten029);
          }
          multipleFilterProperty.value = this.start_date + " - " + this.end_date;
          this.filterArray.push(multipleFilterProperty);
          this.dateFilterAdded = true;
        } else {
          alert(Constants.dateErrorAlert);
        }

      } else {
        multipleFilterProperty.dispalyName = this.filterForms.value.tableFilter.displayName;
        multipleFilterProperty.column = this.filterForms.value.tableFilter.column;
        multipleFilterProperty.value = this.filterForms.value.value;
        this.filterArray.push(multipleFilterProperty);
      }
    } else {
      alert(Constants.duplicateFilterAlert);
    }
    this.filterApplied = true;
    this.initializeFilter();
    this.dateFilterSelected = false;
    this.filterAdded = true;
    this.value = null;
    this.isAddCliecked = false;
  }


  changeValue(event: MatSelectChange<any>) {
      const filter = event.value;
    if (filter.displayName === Constants.date) {
      if (filter.displayName === Constants.scheduledStartDate) {
        this.todayDate = new Date(Constants.scheduledStartActiveDate);
      } else {
        this.todayDate = new Date("");
      }
      this.dateFilterSelected = true;
      this.colorTheme = null;
      this.filterForms.get('value')?.setValue(null);
      this.daterangepickerModel = [];
      this.scheduledStartDate = false;
      this.dateReceived = false;
      this.bsRangeValue = undefined;
    }
    else {
      this.dateFilterSelected = false;
      this.scheduledStartDate = false;
      this.dateReceived = false;
      // this.value = null;
    }
  }

  private initializeFilter() {
    this.filterForms = this.fb.group({
      tableFilter: "",
      value: "",
      valuedate: "",
      multipleFilterarray: [],
    });
  }

  compareFilters(f1: any, f2: any): boolean {
    return f1 && f2 ? f1.displayName === f2.displayName : f1 === f2;
  }

  remove(value: string): void {
    const index = this.filterArray.map((e) => e.value).indexOf(value);
    if (index >= 0) {
      this.filterArray.splice(index, 1);
    }

    const dateIndex = this.filterArray
      .map((e) => e.dateValue)
      .indexOf(Constants.date);
    if (dateIndex <= -1) {
      this.dateFilterAdded = false;
      this.daterangepickerModel = [];
      this.colorTheme = null;
      this.filterForms.get('value')?.setValue(null);
      this.bsRangeValue = undefined;
      this.scheduledStartDate = false;
      this.dateReceived = false;
    }

    if (this.filterArray.length == 0) {
      // this.searchClicked = false;
      this.filterAdded = false;
      this.scheduledStartDate = false;
      this.dateReceived = false;
      this.daterangepickerModel = [];
      this.colorTheme = null;
      this.bsRangeValue = undefined;
      this.selectedFilter.emit(this.filterForms);
    }
    // else if(this.searchClicked == true){
    //   this.selectedFilter.emit(this.filterForms);
    // }
  }



  isArray = () => this.filterForms.value.tableFilter.values && this.filterForms.value.tableFilter.values.length;

  isFilterSet = () => (!(this.filterForms.value.tableFilter.displayName != Constants.displayNameReprocessWoNumber && this.filterForms.value.value) ||
    !(this.filterForms.value.tableFilter.displayName != Constants.displayNameReprocessVisitId && this.filterForms.value.value) ||
  !(this.filterForms.value.tableFilter.displayName != Constants.displayNameWoId && this.filterForms.value.value));

  isWONumberFilterApplied = () => {
    if ((this.filterForms.value.tableFilter.displayName == Constants.displayNameReprocessWoNumber ||
      this.filterForms.value.tableFilter.displayName == Constants.displayNameWoId || this.filterForms.value.tableFilter.displayName == Constants.displayNameReprocessVisitId) && this.filterForms.value.value) {
      return true;
    } else if (this.dateFilterAdded) {
      return true;
    } else {
      return false;
    }
  };

  isAnyFilterSet = () => {
    if (this.filterForms.value.tableFilter && this.filterForms.value.value) {
      return true;
    } else if (this.dateFilterAdded || this.filterArray.length >= 1) {
      return true;
    } else {
      return false;
    }
  }

  isSearchClicked() {
    this.searchClicked = true;
    this.excelClicked = false;
    this.isAddCliecked = false;
  }

  isAddFilterCliecked() {
    this.isAddCliecked = true;
  }

  reset() {
    this.daterangepickerModel = [];
    this.bsRangeValue = undefined;
    this.colorTheme = null;
    this.value = null;
    this.filterApplied = false;
    this.dateFilterSelected = false;
    this.scheduledStartDate = false;
    this.dateReceived = false;
    this.filterAdded = false;
    this.dateFilterAdded = false;
    this.filterArray = [];
    this.initializeFilter();
    if (this.searchClicked == true) {
      this.selectedFilter.emit(this.filterForms);
      this.searchClicked = false;
    }
  }

  private getDatatoExcel(formValues: FormGroup) {
    this.isLoadingResults = true;
    let user: User = this.userService.getUser();
    this.exportService.getDataToExcel(formValues,user.brand).subscribe(
      (response) => {
        this.isLoadingResults = false;
        window.open(response.data, "_blank");
      },
      () => (this.isLoadingResults = false)
    );
  }
  ts() {
    //console.log(this.filterArray);
  }
}
